import React from 'react';
import { Box, Typography } from '@mui/material';
import { GROUP_GAP } from './tileMetrics';

/**
 * A titled group of tiles, rendered as a real `fieldset` with a `legend`.
 *
 * The fieldset is not decoration: it is what tells a screen reader that these
 * controls belong together, so "Brother" is announced inside "Current
 * generation" rather than as one of fifteen loose buttons. The visible heading IS
 * the legend, styled to match the small uppercase treatment Legend, Labels and
 * Tags already use in this sidebar.
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {number} [props.columns=3]  Tiles per row.
 * @param {React.ReactNode} [props.children]
 */
const RelativeGroup = ({ title, columns = 3, children }) => (
  <Box
    component="fieldset"
    sx={{ m: 0, p: 0, border: 0, minWidth: 0, '& + &': { mt: GROUP_GAP } }}
  >
    <Typography
      component="legend"
      sx={{
        p: 0,
        mb: 0.75,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        // text.secondary rather than the text.disabled used elsewhere in this
        // sidebar: text.disabled is rgba(0,0,0,0.38), roughly 2.8:1 on the
        // surface, which fails the 4.5:1 floor this panel has to meet.
        color: 'text.secondary'
      }}
    >
      {title}
    </Typography>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        // Explicit, though it is the default: every control in a row is exactly as
        // tall as the row, which is what stops a shorter symbol or a
        // Tooltip-wrapped tile floating at a different height from its neighbours.
        alignItems: 'stretch',
        gap: 1
      }}
    >
      {children}
    </Box>
  </Box>
);

export default RelativeGroup;
